// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"eb8297bd","464":"7e620a46","558":"71b80d8c","889":"d451c674"}[chunkId] + ".chunk.js";
};